
import {filter} from 'rxjs/operators';
import { Component, ViewEncapsulation, Renderer2, ElementRef, ViewChild, Input, OnDestroy } from '@angular/core';
import { ChatAssessorService } from '../../chat-assessor.service';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';

@AutoUnsubscribe()
@Component({
    selector: 'user-message-render',
    templateUrl: 'user-message-render.component.html',
    styleUrls: ['./user-message-render.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class UserMessageRender implements OnDestroy {

    @ViewChild('chatMessage',  {static: true})
    public chatMessage;

    @Input()
    public data: any;

    @Input()
    public id: any;

    public error: string = '';
    public class: string = '';
    public feedbackSubscription: Subscription;

    constructor(
        private renderer: Renderer2,
        private elementRef: ElementRef,
        private chatAssessorService: ChatAssessorService,
    ) {
        // msg error
        this.feedbackSubscription = this.chatAssessorService.userMessageFeedback$.pipe(
            filter((data) => data.id === this.id))
            .subscribe((data) => this.monitorefeedback(data.type));
    }

    public ngOnInit() {
        this.checkParent();
    }

    public ngOnDestroy() {
        // Não remover, necessário para o funcionamento correto do @AutoUnsubscribe
    }

    /**
     * confere se o elemento anterior é um texto vindo do usuario
     */
    public checkParent() {
        const parent = this.elementRef.nativeElement.previousElementSibling;

        if (parent && parent.firstChild.classList.contains('chat-message--right')) {
            this.renderer.addClass(this.chatMessage.nativeElement, 'text-sequence');
        }
    }

    /**
     * captura os feedbacks emitidos pelo servico
     *
     * @param type tipo do feedback
     */
    public monitorefeedback(type) {
        switch (type) {
            case 'error':
                this.error = 'Ocorreu um erro e sua mensagem não foi enviada.';
                this.class = 'has-error';
                break;
        }
    }

    public reSend($event) {

        $event.preventDefault();

        this.chatAssessorService.sendMessagens({
            message: this.data,
            id: this.id,
        });

        this.error = null;
        this.class = null;
    }

}
